import React, { useEffect } from 'react';
import s from './s.module.less';
import { Spin } from 'antd';
import PracticeFrontPreviewStore from 'store/PracticeFrontPreview';
import { Desktop } from 'assets/preview/Desktop';
import { Mobile } from 'assets/preview/Mobile';
import os from 'assets/preview/OS.svg';
import staticImage from './staticImage.png';

interface IProps {
    showStaticImage?: boolean;
    link?: string;
    onLoad?: (status: boolean) => void;
}

const type = {
    getHeight: 'getHeight',
    refresh: 'refresh',
    returnHeight: 'returnHeight',
    previewLocalSEO: 'previewLocalSEO',
    showLocalSEO: 'showLocalSEO',
    previewContactForm: 'previewContactForm',
    updateServiceStateKey: 'updateServiceStateKey',
    updateServiceStateTypeKey: 'updateServiceStateTypeKey',
};

const Preview: React.FC<IProps> = ({ link, onLoad, showStaticImage = false }) => {
    const [pageHeight, setPageHeight] = React.useState(600);
    //const [pageWidth, setPageWidth] = React.useState('auto');
    const [loading, setLoading] = React.useState(true);
    const [get, set] = PracticeFrontPreviewStore.useStore();
    const flag = get('flag');

    const isMobileMode = get('isMobile');
    const previewLocalSEO = get('previewLocalSEO');
    const showLocalSEO = get('showLocalSEO');
    const previewContactForm = get('previewContactForm');
    const serviceStateKey = get('serviceStateKey');
    const serviceStateTypeKey = get('serviceStateTypeKey');
    //const host = isProductionEnv() ? 'https://provider.kiwihealth.com' : 'https://dev.d31frxe1u41op.amplifyapp.com';
    //const host = isProductionEnv() ? 'https://www.kiwihealth.com' : 'http://localhost:3008';
    // const host = isProductionEnv() ? 'https://www.kiwihealth.com' : 'https://dev-kiwihealth.boxpractice.com';

    //const host = isProductionEnv() ? 'https://provider.kiwihealth.com' : 'http://localhost:3009';

    const [currentLink, setCurrentLink] = React.useState('');

    useEffect(() => {
        if (link) {
            setCurrentLink(`${link}?isPreview=true`);
        }
    }, [link]);

    const sendHeight = () => {
        try {
            const pfIframe: any = document.getElementById('pf-preview');
            const iframeWin = pfIframe.contentWindow;
            const message = {
                type: type.getHeight,
            };
            iframeWin.postMessage(message, '*');
        } catch (e) {
            console.error(e);
        }
    };

    const sendRefresh = () => {
        try {
            const pfIframe: any = document.getElementById('pf-preview');
            const iframeWin = pfIframe.contentWindow;
            const message = {
                type: type.refresh,
            };
            iframeWin.postMessage(message, '*');
            setTimeout(() => {
                sendHeight();
            }, 5000);
        } catch (e) {
            console.error(e);
        }
    };

    useEffect(() => {
        const pfIframe: any = document.getElementById('pf-preview');
        // eslint-disable-next-line func-names
        pfIframe.onload = function () {
            onLoad?.(true);
            //获取 iframe 内容的高度
            setTimeout(() => {
                sendHeight();
            }, 5000);
        };
    }, []);

    useEffect(() => {
        window.addEventListener('message', (event) => {
            if (event?.data?.type === type.returnHeight) {
                const msg = event.data;
                const { height } = msg;
                setPageHeight(height);
            }
        });
    }, []);

    useEffect(() => {
        if (flag) {
            sendRefresh();
        }
    }, [flag]);

    useEffect(() => {
        try {
            const pfIframe: any = document.getElementById('pf-preview');
            const iframeWin = pfIframe.contentWindow;
            const message = {
                type: type.showLocalSEO,
                data: showLocalSEO,
            };
            iframeWin.postMessage(message, '*');
            const message2 = {
                type: type.previewLocalSEO,
                data: previewLocalSEO,
            };
            iframeWin.postMessage(message2, '*');
            const message3 = {
                type: type.previewContactForm,
                data: previewContactForm,
            };
            iframeWin.postMessage(message3, '*');

            const message4 = {
                type: type.updateServiceStateKey,
                data: serviceStateKey,
            };
            iframeWin.postMessage(message4, '*');

            const message5 = {
                type: type.updateServiceStateTypeKey,
                data: serviceStateTypeKey,
            };
            iframeWin.postMessage(message5, '*');
        } catch (e) {
            console.error(e);
        }
    }, [previewLocalSEO, showLocalSEO, previewContactForm, serviceStateKey, serviceStateTypeKey]);

    let editAreaHeight: number = 0;
    const leftDom = document.getElementById('pf-left');
    if (leftDom) {
        editAreaHeight = leftDom.clientHeight;
    }

    let height = pageHeight;

    if (showLocalSEO && editAreaHeight && editAreaHeight > 900) {
        //force scroll
        height = editAreaHeight;
    }

    return (
        <div className={s.wrap}>
            <div className={s.modeWrap}>
                <span
                    onClick={() => {
                        set('isMobile', false);
                    }}
                    className={isMobileMode ? '' : s.active}
                >
                    <Desktop />
                </span>
                <span
                    onClick={() => {
                        set('isMobile', true);
                    }}
                    className={isMobileMode ? s.active : ''}
                >
                    <Mobile />
                </span>

            </div>
            <div
                className={isMobileMode ? `${s.iframeWrap} ${s.iframeWrapMobile}` : s.iframeWrap}
            >
                <div className={s.topBar}>
                    <img src={os} />
                </div>
                {
                    showStaticImage ? (
                        <div className={s.staticImage}>
                            <img src={staticImage} />
                        </div>
                    ) : (
                        <Spin spinning={loading}>
                            <iframe
                                style={{
                                    height: `${height}px`,
                                }}
                                onLoad={() => {
                                    setLoading(false);
                                }}
                                src={currentLink}
                                scrolling="auto"
                                id="pf-preview"
                                title="preview"
                            />
                        </Spin>
                    )
                }

                {/* <div
                    onClick={(e) => {
                        e.stopPropagation();
                    }}
                    className={s.mask}
                /> */}
            </div>
        </div>
    );
};

export default Preview;
